import { StartupInfoForm } from '@ideoz/ui';
import { useStartupProfile } from './useStartupProfile';

interface StartupProfileModuleProps {
  startupId: string;
}

/**
 * Startup-entity profile module: edit the startup's name, target ICP, and
 * problem context via the shared StartupInfoForm.
 */
export function StartupProfileModule({ startupId }: StartupProfileModuleProps): JSX.Element {
  const { project, initialValues, updateStartupInfo } = useStartupProfile(startupId);

  if (!project) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <section className="mx-auto w-full max-w-5xl px-6 py-10">
      <header className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Startup Profile</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Update {project.name}'s details, target ICP, and problem context.
        </p>
      </header>

      <div className="bg-surface rounded-2xl border border-gray-100 dark:bg-gray-800 dark:border-gray-700 p-6">
        <StartupInfoForm
          initialValues={initialValues}
          mode="update"
          onSubmit={async (data) => {
            await updateStartupInfo(data);
          }}
          isWeb
        />
      </div>
    </section>
  );
}
